<div>
  <bottom-sheet-title [title]="'Edit Tag'"></bottom-sheet-title>
  <div class="p-2">
    <div class="flex flex-col">
      <!-- Name -->
      <div class="mb-4">
        <span class="text-gray-400 mb-2 block">Name</span>
        <div class="flex items-center">
          <input
            class="block w-full p-2 rounded"
            type="text"
            [disabled]="!!newTag.isArchived"
            placeholder="Name..."
            [value]="newTag.fullPath"
            (input)="updateName(newTag, $event)"
          />
        </div>
      </div>
      <!-- Color -->
      <div class="mb-4" *ngIf="isRoot(data.tag.fullPath) && !newTag.isArchived">
        <span class="text-gray-400 mb-2 block">Color</span>
        <div class="overflow-x-scroll no-scrollbar">
          <div class="flex color-items w-fit">
            <div
              class="color-item !bg-green-500 border border-green-700"
              [ngClass]="{ selected: newTag.color === 'green' }"
              (click)="newTag.color = 'green'"
            >
              <mat-icon class="text-white">check</mat-icon>
            </div>
            <div
              class="color-item !bg-orange-500 border border-orange-700"
              [ngClass]="{ selected: newTag.color === 'orange' }"
              (click)="newTag.color = 'orange'"
            >
              <mat-icon class="text-white">check</mat-icon>
            </div>
            <div
              class="color-item border border-gray-700"
              [ngClass]="{ selected: newTag.color === 'white' }"
              (click)="newTag.color = 'white'"
            >
              <mat-icon class="text-white">check</mat-icon>
              <mat-icon
                *ngIf="
                  newTag.color !== 'white' &&
                  !authService.isPro &&
                  !authService.FREE_LIMITATIONS.availableColors.includes(
                    'white'
                  )
                "
                class="text-white opacity-50"
                >star</mat-icon
              >
            </div>
            <div
              class="color-item !bg-red-500 border border-red-700"
              [ngClass]="{ selected: newTag.color === 'red' }"
              (click)="newTag.color = 'red'"
            >
              <mat-icon class="text-white">check</mat-icon>
              <mat-icon
                *ngIf="
                  newTag.color !== 'red' &&
                  !authService.isPro &&
                  !authService.FREE_LIMITATIONS.availableColors.includes('red')
                "
                class="text-white opacity-50"
                >star</mat-icon
              >
            </div>
            <div
              class="color-item !bg-blue-500 border border-blue-700"
              [ngClass]="{ selected: newTag.color === 'blue' }"
              (click)="newTag.color = 'blue'"
            >
              <mat-icon class="text-white">check</mat-icon>
              <mat-icon
                *ngIf="
                  newTag.color !== 'blue' &&
                  !authService.isPro &&
                  !authService.FREE_LIMITATIONS.availableColors.includes('blue')
                "
                class="text-white opacity-50"
                >star</mat-icon
              >
            </div>
            <div
              class="color-item !bg-yellow-500 border border-yellow-700"
              [ngClass]="{ selected: newTag.color === 'yellow' }"
              (click)="newTag.color = 'yellow'"
            >
              <mat-icon class="text-white">check</mat-icon>
              <mat-icon
                *ngIf="
                  newTag.color !== 'yellow' &&
                  !authService.isPro &&
                  !authService.FREE_LIMITATIONS.availableColors.includes(
                    'yellow'
                  )
                "
                class="text-white opacity-50"
                >star</mat-icon
              >
            </div>
            <div
              class="color-item !bg-purple-500 border border-purple-700"
              [ngClass]="{ selected: newTag.color === 'purple' }"
              (click)="newTag.color = 'purple'"
            >
              <mat-icon class="text-white">check</mat-icon>
              <mat-icon
                *ngIf="
                  newTag.color !== 'purple' &&
                  !authService.isPro &&
                  !authService.FREE_LIMITATIONS.availableColors.includes(
                    'purple'
                  )
                "
                class="text-white opacity-50"
                >star</mat-icon
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Summary Type -->
      <div class="mb-4" *ngIf="isRoot(data.tag.fullPath) && !newTag.isArchived">
        <span class="text-gray-400 mb-2 block">Summary type</span>
        <div class="flex flex-wrap justify-between summary-type-items">
          <div
            class="w-[48%] h-[100px] bg-[var(--surface-container-color)] mb-4 rounded flex flex-col text-[var(--on-surface)] justify-center items-center"
            [ngClass]="{ selected: newTag.summary === 'expenditureProgress' }"
            (click)="newTag.summary = summary.expenditureProgress"
          >
            <mat-icon>shopping_bag</mat-icon>
            <span>Expenditure progress</span>
          </div>
          <div
            class="w-[48%] h-[100px] bg-[var(--surface-container-color)] mb-4 rounded flex flex-col text-[var(--on-surface)] justify-center items-center"
            [ngClass]="{ selected: newTag.summary === 'incomeProgress' }"
            (click)="newTag.summary = summary.incomeProgress"
          >
            <mat-icon>savings</mat-icon>
            <span>Income progress</span>
          </div>
          <div
            class="w-[48%] h-[100px] bg-[var(--surface-container-color)] mb-4 rounded flex flex-col text-[var(--on-surface)] justify-center items-center"
            [ngClass]="{ selected: newTag.summary === 'runningBalance' }"
            (click)="newTag.summary = summary.runningBalance"
          >
            <mat-icon>balance</mat-icon>
            <span>Running balance</span>
          </div>
          <div
            class="w-[48%] h-[100px] bg-[var(--surface-container-color)] mb-4 rounded flex flex-col text-[var(--on-surface)] justify-center items-center"
            [ngClass]="{ selected: newTag.summary === 'none' }"
            (click)="newTag.summary = summary.none"
          >
            <mat-icon>self_improvement</mat-icon>
            <span>None</span>
          </div>
        </div>
      </div>
      <!-- Planned expenditure -->
      <div
        class="mb-4"
        *ngIf="
          !newTag.isArchived &&
          ((isRoot(newTag.fullPath) &&
            newTag.summary === 'expenditureProgress') ||
            (!isRoot(newTag.fullPath) &&
              getTopLevelTag(newTag, data.tags)?.summary ===
                'expenditureProgress'))
        "
      >
        <div class="flex justify-between">
          <span class="text-gray-400 mb-2 block">Planned expenditure</span>
          <period-chooser
            *ngIf="getTopLevelTag(newTag, data.tags)?.isPeriodic"
          ></period-chooser>
        </div>
        <input
          type="number"
          [(ngModel)]="plannedExpenditure"
          class="block w-full p-2 rounded"
          placeholder="Planned expenditure..."
        />
      </div>
      <!-- Planned income -->
      <div
        class="mb-4"
        *ngIf="
          getTagSummary(newTag, data.tags) === 'incomeProgress' &&
          !newTag.isArchived
        "
      >
        <div class="flex justify-between">
          <span class="text-gray-400 mb-2 block">Planned income</span>
          <period-chooser
            *ngIf="getTopLevelTag(newTag, data.tags)?.isPeriodic"
          ></period-chooser>
        </div>
        <input
          type="number"
          [(ngModel)]="plannedIncome"
          class="block w-full p-2 rounded"
          placeholder="Planned income..."
        />
      </div>

      <span
        class="text-gray-400 mb-4"
        *ngIf="!isRoot(newTag.fullPath)! && !newTag.isArchived"
        >Color and Summary Type can be set on top level tags only.</span
      >
      <span class="text-gray-400 mb-4" *ngIf="newTag.isArchived"
        >Archived tags are hidden from the sidebar and autocomplete.</span
      >

      <!-- Other -->
      <div class="mb-4">
        <span class="text-gray-400 mb-2 block">Actions</span>
        <div *ngIf="!newTag.isArchived" class="py-4 border-t">
          <mat-icon class="text-blue-500 align-middle mr-2"
            >content_copy</mat-icon
          >
          <span class="text-blue-500 align-middle" (click)="duplicateTag()"
            >Duplicate tag</span
          >
        </div>
        <div *ngIf="!newTag.isArchived" class="py-4 border-t">
          <mat-icon class="text-red-500 align-middle mr-2">archive</mat-icon>
          <span class="text-red-500 align-middle" (click)="archiveTag()"
            >Archive tag</span
          >
        </div>
        <div *ngIf="newTag.isArchived" class="py-4 border-t">
          <mat-icon class="text-blue-500 align-middle mr-2">unarchive</mat-icon>
          <span class="text-blue-500 align-middle" (click)="archiveTag(false)"
            >Unarchive tag</span
          >
        </div>
        <div class="py-4 border-t border-b">
          <mat-icon class="text-red-500 align-middle mr-2">delete</mat-icon>
          <span class="text-red-500 align-middle" (click)="deleteTag()"
            >Delete tag</span
          >
        </div>
      </div>
    </div>
  </div>

  <bottom-sheet-controls
    *ngIf="!newTag.isArchived"
    (onCancel)="_bottomSheetRef.dismiss()"
    (onSubmit)="updateTag()"
    [submitText]="getSubmitText()"
  ></bottom-sheet-controls>
</div>
